
// const API_UPDATE_METAFILDS_UPLOAD = 'https://addons.novicos.com/update_metafield.php';
// const API_UPDATE_METAFILDS_UPLOAD_META = 'https://addons.novicos.com/customers_data/form_data_meta.php';
// const API_UPDATE_METAFILDS_UPLOAD_META_customer = 'http://addons.novicos.com/customers_data/form-data-meta-update.php';
// const API_SUBMIT_FROM_SEND_MAIL= 'https://addons.novicos.com/form-data-sent/send_email.php';
// const pdf_ganret = 'https://skript.novicos.de/pdf.php';

const API_UPDATE_METAFILDS_UPLOAD = 'https://skript.novicos.de/import-export/update_metafield.php';
const API_UPDATE_METAFILDS_UPLOAD_META = 'https://skript.novicos.de/import-export/customers_data/form_data_meta.php';
const API_UPDATE_METAFILDS_UPLOAD_META_customer = 'https://skript.novicos.de/import-export/customers_data/form-data-meta-update.php';
const API_SUBMIT_FROM_SEND_MAIL= 'https://skript.novicos.de/import-export/form-data-sent/send_email.php';
const API_SUBMIT_FROM_SEND_MAIL_scadas_xs= 'https://skript.novicos.de/import-export/form-data-sent/scadas_xs.php';

const products_search_new = 'https://skript.novicos.de/import-export/products-search-new.php';
const products_search = 'https://skript.novicos.de/import-export/products-search.php';
const zipfile_create = 'https://skript.novicos.de/import-export/zipfile-create.php';
let pdf_ganret = 'https://skript.novicos.de/Pdf/pdf.php';
  if(document.body.classList.contains('template-anovis-configuration-plan')){
     pdf_ganret = 'https://skript.novicos.de/Pdf/pdf-anovis.php';  
  }
const upload_file = 'https://skript.novicos.de/canvasimageupload/upload_file.php'

function people_data_upload(params,metfilds_key,checkrefreask) {
  if(!customer_ID) return
 
  console.log(params);
  const formdata = new FormData();
  formdata.append("customer_id", customer_ID);
  formdata.append("type", "json");
  formdata.append("json", JSON.stringify(params));
  formdata.append("namespace", "custom");
  formdata.append("key", metfilds_key);

  console.log("formdata",formdata)

  const requestOptions = {
    method: "POST",
    body: formdata,
    redirect: "follow"
  };

  fetch(API_UPDATE_METAFILDS_UPLOAD, requestOptions)
    .then((response) => response.json())
    // .then((result) => console.log(result))
      .then((result) => {
          if(checkrefreask){
            window.location.reload();
          }
        if (result.success == true) {
          console.log('data upload in metafilds');
        }
        
          // reloadManagePeopleSection();
      
    })
    .catch((error) => console.error(error));
  
}


// async function people_data_upload_meta(params, metfilds_key) {
//   console.log("metfilds_key", metfilds_key);

//   if (!customer_ID) return null;
  
//   console.log("params",params);
//   const formdata = new FormData();
//   formdata.append("customer_id", customer_ID);
//   formdata.append("type", "json");
//   // formdata.append("json", JSON.stringify(params));
//   formdata.append("namespace", "custom");
//   formdata.append("key", metfilds_key);

//   // params[0].form_data.forEach(input => {
//   //  console.log("input...",input)
//   // });

//   // Debug FormData
//   // for (const [key, value] of formdata.entries()) {
//   //   console.log(key, value);
//   //   formdata.append(key, value);
//   // }
//   const finalData = Object.values(params)[0];
//   // 1. full JSON
//   formdata.append("json", JSON.stringify(finalData));
  
//   // 2. form_data fields separately
//   Object.entries(finalData.form_data).forEach(([key, value]) => {
//     formdata.append(key, value);
//   });

  
//   const requestOptions = {
//     method: "POST",
//     body: formdata
//   };
  
//   console.log("requestOptions...",requestOptions);
//   try {
//     const response = await fetch(
//       API_UPDATE_METAFILDS_UPLOAD_META,
//       requestOptions
//     );

//     const result = await response.json();

//     console.log("data upload in metafields", result);

//     return result; // ✅ IMPORTANT
//   } catch (error) {
//     console.error("Upload error", error);
//     return null;
//   }
// }


async function people_data_upload_meta(params, metfilds_key) {
  console.log("metfilds_key", metfilds_key);

  if (!customer_ID){
     document.body.classList.remove("pdf-mode");
    return null;
  } 
  
  console.log("params",params);
  const dynamicKey = Object.keys(params)[0];
  const formdata = new FormData();
  formdata.append("customer_id", customer_ID);
  formdata.append("type", "json");
  formdata.append("json", JSON.stringify(params[dynamicKey]));
  formdata.append("namespace", "custom");
  formdata.append("key", metfilds_key);


  console.log("Hidden Field Value:", params[dynamicKey]);
  const formFields = params?.form_data?.form_data;
  console.log("formFields",formFields);
  if (formFields) {
    Object.entries(formFields).forEach(([key, value]) => {
      formdata.append(key, value);
    });
  }
  

  const requestOptions = {
    method: "POST",
    body: formdata
  };

  try {
    const response = await fetch(
      API_UPDATE_METAFILDS_UPLOAD_META,
      requestOptions
    );

    const result = await response.json();

    console.log("data upload in metafields", result);

    return result; // ✅ IMPORTANT
  } catch (error) {
    console.error("Upload error", error);
     document.body.classList.remove("pdf-mode");
    return null;
  }
}

async function load_product_api(data){
  console.log("data DD-API",data);
  try {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify(data);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw
    };

    const response = await fetch(products_search, requestOptions);
    // const response = await fetch(products_search_new, requestOptions);

    const result = await response.json();
    if (result.error) return false;
console.log("result",result.data[0])
    return result.data;   // ✅ THIS WAS MISSING

  } catch (error) {
    console.error(error);
    return null;
  }
}



async function load_product_api_xs(data){
  console.log("data",data);
  try {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify(data);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw
    };

    const response = await fetch(products_search, requestOptions);
    // const response = await fetch(products_search_new, requestOptions);

    const result = await response.json();
    if (result.error) return false;
console.log("result",result.data[0])
    return result.data;   // ✅ THIS WAS MISSING

  } catch (error) {
    console.error(error);
    return null;
  }
}



async function ZIPGenerate(data){
  console.log(data);
const myHeaders = new Headers();
myHeaders.append("Accept", "application/json");
myHeaders.append("Content-Type", "application/json");

const raw = JSON.stringify(data);
const requestOptions = {
  method: "POST",
  headers: myHeaders,
  body: raw,
  redirect: "follow"
};

fetch(zipfile_create, requestOptions)
  .then((response) => response.json())
  // .then((result) => console.log(result))
  .then((result) => {    
                if(result.error) return null;
                localStorage.setItem("ZipFile", JSON.stringify(result.data)); 
                const ZIP_filds = document.querySelector('[data-from-created-Zip]') || null;
               if(ZIP_filds) ZIP_filds.value = result.data;
                return result.data;                 
            })
  .catch((error) => console.error(error));

}


function updatemeta(payload, checkrefreask = true) {


   const formdata = new FormData();
  formdata.append("type", "json");
  formdata.append("json", JSON.stringify(payload));

  // const requestOptions = {
  //   method: 'POST',
  //   headers: {
  //     'Content-Type': 'application/json'
  //   },
  //   body: formdata,
  //     redirect: "follow"
  // };

  const requestOptions = {
  method: "POST",
  body: formdata,
  redirect: "follow"
};


  console.log("requestOptions",requestOptions);
  // return;

  return fetch(API_UPDATE_METAFILDS_UPLOAD_META_customer, requestOptions)
    .then((response) => response.json())
    .then((result) => {

      if (checkrefreask) {
        window.location.reload();
      }

      // if (result.success === true) {
        console.log(result.status,'data upload in metafields');
      // }

      return result; // ✅ important for await
    })
    .catch((error) => {
      console.error(error);
      throw error; // ✅ propagate error to caller
    });
}










async function pdfGenerate(data) {  
  
const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

const raw = JSON.stringify(data);

const requestOptions = {
  method: "POST",
  headers: myHeaders,
  body: raw,
  redirect: "follow"
};


 try {
    const response = await fetch(
      pdf_ganret,
      requestOptions
    );

    const result = await response.json();
    console.log("result pdf",result);
    if (result.error) return null;

    localStorage.setItem("saved_pdf", result.link);
    // console.log("result.link",result.link);
    const pdf_filds = document.querySelector('[data-from-created-pdf]') || null;
    if(pdf_filds) pdf_filds.value = result.link;

    return result.link; // ✅ THIS RETURNS TO CALLER
  } catch (error) {
    console.error(error);
    return null;
  }

}


 async function GeneratePDF() {

    const element = document.getElementById("pdfContent");
    const htmlContent = element.outerHTML;
    
      //     // 1. Clone element (so original DOM is untouched)
      // const clone = element.cloneNode(true);

      // // 2. Find all elements that have srcset
      // const elementsWithSrcset = clone.querySelectorAll("[srcset]");

      // // 3. Remove srcset attribute
      // elementsWithSrcset.forEach(el => {
      //   el.removeAttribute("srcset");
      // });

      // // 4. Get clean HTML
      // const htmlContent = element.outerHTML;

console.log(htmlContent);

    // Add PDF mode (optional)
    // document.body.classList.add("pdf-mode");

    // // Wait for DOM to fully render (important for html2canvas)
    // setTimeout(function () {

    //     html2canvas(element, {
    //         scale: 2,
    //         useCORS: true
    //     }).then( async canvas => {

    //         const imgData = canvas.toDataURL("image/jpeg", 1.0);
    //         const { jsPDF } = window.jspdf;

    //         const pdf = new jsPDF("p", "mm", "a4");
    //         const pageWidth = pdf.internal.pageSize.getWidth();
    //         const imgWidth = pageWidth;
    //         const imgHeight = canvas.height * (imgWidth / canvas.width);

    //         pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);

    //         // pdf.save("design-preview.pdf");

    //         // Remove mode (optional)
    //         document.body.classList.remove("pdf-mode");



    //          const pdfBase64 = pdf.output("datauristring"); 
    //     // OR clean version:
    //     const pdfBase64Clean = pdfBase64.replace("data:application/pdf;base64,", "");

      

    //     document.body.classList.remove("pdf-mode");
    //     const pdf_customiz = await pdfGenerate (pdfBase64Clean);
    //     // console.log("pdf_customiz",pdf_customiz);
           
    //     // console.log("pdf_customiz",pdf_customiz);
    //     })
    // }, 300);
    const pdf_customiz = await pdfGenerate (htmlContent);         
  }




  async function submit_from_PHP(form_) {
  //  const formData = new FormData(this.form);
  //  const formData = form_;
  const data = {};  
          form_.forEach((value, key) => {
            // handle multiple fields with same name (checkboxes, arrays)                        
              if (data[key]) {
                if (Array.isArray(data[key])) {
                  data[key].push(value);
                } else {
                  data[key] = [data[key], value];
                }
              } else {
                data[key] = value;
              }                 
          });
          console.log("data _api file_ddata",data);

  const requestOptions = {
    method: "POST",
    body: form_
  };

  try {
    const response = await fetch(
      API_SUBMIT_FROM_SEND_MAIL,
      requestOptions
    );

    const result = await response.json();  
        const data = Object.fromEntries(form_.entries());  
        localStorage.setItem("form_data", JSON.stringify(data)); 
    storeData();
    // return result;
    
      return {
        result: result,
        data_: data
      }
    
  } catch (error) {
    console.error("Upload error", error);
    return null;
  }
}


async function submit_from_PHP_scadasxs(form_) {


  const data = {};
const temp = {};
const orderedKeys = []; // 🔥 track order

form_.forEach((value, key) => {

  const inputs = document.querySelectorAll(`input[name="${key}"], textarea[name="${key}"]`);
  let input = [...inputs].find(el => el.value == value) || inputs[0];
  if (!input) return;

  if (input.type === "checkbox" && !input.checked) return;

  const parent = input.closest('[data-collection-handle]');
  const match = key.match(/__([a-zA-Z]+)__(.*)\]/);

  // ✅ PRODUCT / QUANTITY
  if (match && parent) {
    const collection = parent.getAttribute('data-collection-handle');

    if (!orderedKeys.includes(collection)) {
      orderedKeys.push(collection); // track position
    }

    const type = match[1];
    const uniqueKey = match[2];

    if (!temp[collection]) temp[collection] = {};
    if (!temp[collection][uniqueKey]) temp[collection][uniqueKey] = {};

    if (type === "product") temp[collection][uniqueKey].product = value;
    if (type === "quantity") temp[collection][uniqueKey].quantity = value;

  } else {
    // ✅ NORMAL FIELDS (keep order)
    if (!orderedKeys.includes(key)) {
      orderedKeys.push(key);
    }

    if (data[key]) {
      if (Array.isArray(data[key])) {
        data[key].push(value);
      } else {
        data[key] = [data[key], value];
      }
    } else {
      data[key] = value;
    }
  }
});


// ✅ Build final structured collections
const collectionsData = {};

Object.keys(temp).forEach(collection => {
  collectionsData[collection] = {};

  Object.values(temp[collection]).forEach(item => {
    if (item.product && item.quantity && Number(item.quantity) > 0) {
      collectionsData[collection][item.product] = Number(item.quantity);
    }
  });
});


// ✅ FINAL ORDERED OBJECT
const finalData = {};

orderedKeys.forEach(key => {
  if (collectionsData[key]) {
    finalData[key] = collectionsData[key];
  } else if (data[key] !== undefined) {
    finalData[key] = data[key];
  }
});

console.log("FINAL ORDERED DATA =>", finalData);


const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");
myHeaders.append("Cookie", "shopifyy=a1dc9087-ebeb-49d6-9507-6555d25e7451");


  const requestOptions = {
    method: "POST",
    body: JSON.stringify(finalData),
  };

  try {
    const response = await fetch(
      API_SUBMIT_FROM_SEND_MAIL_scadas_xs,
      requestOptions
    );

    const result = await response.json();  
        const data = Object.fromEntries(form_.entries());  
        localStorage.setItem("form_data", JSON.stringify(data)); 
    storeData();
    // return result;
    
      return {
        result: result,
        data_: data
      }
    
  } catch (error) {
    console.error("Upload error", error);
    return null;
  }
}



async function updateimage(base64) {
  try {
    const response = await fetch(upload_file, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        image: base64
      })
    });

    if (!response.ok) {
      throw new Error('Image upload failed');
    }

    const data = await response.json();
    localStorage.setItem("mainconfiimage", data.url);
    return data.url;

  } catch (error) {
    console.error('updateimage error:', error);
    throw error; 
  }
}
